import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { useLocation } from "react-router-dom";
import { SocialLink } from "../../common/SocialLink";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { getAppStoreUrl } from "../../appStore";
import { getAppStoreBadge } from "../../appStoreBadge";
import { getLanguageFromPath } from "../../languages";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  FooterContainer,
  Language,
} from "./styles";
const Footer = ({ t }: { t: TFunction }) => {
  const location = useLocation();
  const currentLanguage = getLanguageFromPath(location.pathname);

  return (
    <>
      <FooterSection>
        <Container>
          <Row
            justify="space-between" 
            style={{ paddingTop: "1rem" }}
          >
            <Col lg={10} md={10} sm={12} xs={12} style={{paddingBottom: "1rem"}}>
              <Language>{t("Contact")}</Language>
              <a href="mailto:contact@babli.app">
                <Chat>{t(`contact@babli.app`)}</Chat>
              </a>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12} style={{paddingBottom: "1rem"}}>
              <Title>{t("Policy")}</Title>
              <a
                href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
                target="_blank"
                rel="noreferrer"
              >
                <Large>{t("Terms of Use")}</Large>
              </a>
              <a href="/privacy_policy.html" target="_blank" rel="noreferrer">
                <Large>{t("Privacy Policy")}</Large>
              </a>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <img src="/img/icons/babli_logo_192.png" alt="Babli App Logo" width="55px" height="55px"/>
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="https://www.instagram.com/babli_app"
                src="instagram.svg"
                alt="Babli App on Instagram"
              />
              <SocialLink
                href="https://www.threads.net/@babli_app"
                src="threads.svg"
                alt="Babli App on Threads"
              />
              <a href={getAppStoreUrl(currentLanguage)} target="_blank" rel="noreferrer">
                <SvgIcon src={getAppStoreBadge(currentLanguage)} alt="Download on the App Store" height="50px" width="150px"/>
              </a>
            </FooterContainer>

          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
